import ReactDOM from "react-dom";
import React from "react";
import { TabPanel } from "react-tabs";
import FeatureGrid from "../components/feature-grid/FeatureGrid";

const init = () => {
  let mountPoint = document.querySelector("#FeatureGrid");
  let tabsData = [];

  if (mountPoint) {
    try {
      tabsData = mountPoint.getAttribute("data-feature-grid-tabs");
      tabsData = JSON.parse(tabsData);

      ReactDOM.render(
        <FeatureGrid tabsData={tabsData}>
          {Array.from(mountPoint.children).map(function (panel, index) {
            // do whatever
            return (
              <TabPanel key={index}>
                <div
                  dangerouslySetInnerHTML={{ __html: panel.outerHTML }}
                ></div>
              </TabPanel>
            );
          })}
        </FeatureGrid>,
        mountPoint
      );
    } catch (e) {
      console.warm("Tabs data is missing or malformed.");
    }
  }
}

// Init on initial page load
init();
